import { connect, MapDispatchToProps } from 'react-redux';
import { viewProfileAsVisitor } from '../../actions/profileOwner';
import { Props } from './ViewAsVisitorBar';

type DispatchProps = Pick<Props, 'viewAsVisitor'>;
type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  viewAsVisitor: viewProfileAsVisitor,
};

export default connect(null, mapDispatchToProps);
